export default __webpack_public_path__ + "static/download-and-log-in-dab59e51a9898473c703b1f0d1de0572.gif";